import React from 'react';
import { motion } from 'framer-motion';
export function BackgroundEffects() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-129">
      {/* Radial Gradients */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#7c3aed] rounded-full mix-blend-screen filter blur-[120px] opacity-20 animate-pulse-slow" data-id="element-130" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-[#a855f7] rounded-full mix-blend-screen filter blur-[150px] opacity-20 animate-pulse-slow" style={{
      animationDelay: '2s'
    }} data-id="element-131" />
      <div className="absolute top-[40%] left-[50%] translate-x-[-50%] w-[60%] h-[60%] bg-[#fbbf24] rounded-full mix-blend-screen filter blur-[180px] opacity-10" data-id="element-132" />

      {/* Sacred Geometry SVG Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fbbf24' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      backgroundSize: '60px 60px'
    }} data-id="element-133" />

      {/* Floating Particles */}
      {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-white rounded-full shadow-[0_0_10px_#fff]" initial={{
      x: Math.random() * (typeof window !== 'undefined' ? window.innerWidth : 1000),
      y: Math.random() * (typeof window !== 'undefined' ? window.innerHeight : 1000),
      opacity: Math.random() * 0.5 + 0.2,
      scale: Math.random() * 2
    }} animate={{
      y: [null, Math.random() * -200 - 100],
      opacity: [null, 0]
    }} transition={{
      duration: Math.random() * 10 + 10,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-134" />)}
    </div>;
}